import React, { Component } from "react";
import { getStaticText } from '../../../lables/lablesService';
import Spinner from '../../../components/spinner-component/Spinner';
import TransportationToOrderCategories from '../api/transportationToOrderCategories';
import TransportationToOrderPosts from '../api/transportationToOrderPosts';
import PostForm from './postForm';
import PostsList from './postsList';
import Popup from "reactjs-popup";

import 'reactjs-popup/dist/index.css';
import '../../../scss/os-global.scss';


class TransportationToOrderPostsPage extends Component {

    constructor(props) {
        super(props);

        this.categories = {};
        this.posts = [];
        this.page = 1;
        this.per_page = 10;
        this.all_pages = 0;
        this.order = {'type_id' : 'ASC', 'position' : "ASC"};

        this.save_type_process = false;
        this.info = {};
        this.empty_info = {
            'id' : 0,
            'image' : '',
            'image_name' : '',
            'title' : '',
            'type_id' : 0,
            'content' : '',
            'active' : 1,
            'position' : 99999
        };

        this.state = {
            'has_data' : false,
            'show_popup' : false
        };
    }


    /*====================================================================================*/
    /*====================================================================================*/
    /*====================================================================================*/
    async changePage (page_number = 1) {
        this.page = page_number;
        await this.getDataList();
    }


    async changeOrder (new_order = {}) {
        this.order = new_order;
        await this.getDataList();
    }


    async formCallback () {
        this.page = 1;
        this.popupToggle();
        await this.getDataList();
    }


    openAddNewForm () {
        Object.assign(
            this.info,
            this.empty_info
        );
        this.popupToggle();
    }


    openEditForm ( row_for_edit = {} ) {
        Object.assign(
            this.info,
            row_for_edit,
            {
                'image' : TransportationToOrderPosts.getImageUrl( row_for_edit.image )
            }
        );
        this.popupToggle();
    }


    popupToggle () {
        this.setState({
            'show_popup' : !this.state.show_popup
        });
    }
    /*====================================================================================*/
    /*====================================================================================*/
    /*====================================================================================*/


    async deletePost ( post_for_delete ) {
        if ( !window.confirm(getStaticText('remove_confirm_text')) )
            return false;

        let result = await TransportationToOrderPosts.remove( post_for_delete.id );
        if ( !result ) {
            window.alert( getStaticText('remove_error') );
        } else {
            window.alert( getStaticText('remove_success') );
            this.page = 1;
            this.getDataList();
        }
    }


    async getDataList () {
        this.setState({'has_data' : false});

        let list_response = await TransportationToOrderPosts.list({
                                                    'page' : this.page,
                                                    'per_page' : this.per_page,
                                                    'order' : this.order
                                                });
        if ( typeof(list_response.rows) !== 'undefined' ) {
            this.posts = list_response.rows;
            this.all_pages = list_response.all_pages;
        }

        this.setState({'has_data' : true});
    }


    async componentDidMount () {
        let list_response = await TransportationToOrderCategories.list({
                                                    'page' : 1,
                                                    'per_page' : 0,
                                                    'order' : {'id' : 'DESC'}
                                                });
        if ( typeof(list_response.rows) !== 'undefined' ) {
            for ( let key in list_response.rows ) {
                this.categories[list_response.rows[key].id] = list_response.rows[key].name;
            }
        }

        await this.getDataList();
    }


    render () {
        let content = null;
        if ( !this.state.has_data ) {
            content = (<div className="col-lg-12 text-center">{<Spinner />}</div>);
        } else {
            content = (<>
                <div className="col-lg-12 os-text-right">
                    <button 
                        onClick={this.openAddNewForm.bind(this)}
                        className="btn btn-success text-white"
                    >
                        {getStaticText('ttop_add_new_button_label')}
                    </button>
                </div>

                <Popup
                    open={this.state.show_popup}
                    closeOnDocumentClick={false}
                    closeOnEscape={false}
                    className="os-popup"
                >
                    <>
                        <div className="os-popup-header">
                            <span className="op-popup-title">
                                {this.info.id ? getStaticText('ttop_edit_popup_title') : getStaticText('ttop_add_new_popup_title')}
                            </span>
                            <button
                                onClick={this.popupToggle.bind(this)}
                                className="os-popup-close-button"
                            >
                                <i className="fa fa-times" />
                            </button>
                        </div>

                        <div className="os-popup-body">
                            <PostForm
                                info={this.info}
                                categories={this.categories}
                                formCallback={this.formCallback.bind(this)}
                            />
                        </div>
                    </>
                </Popup>

                <PostsList 
                    posts={this.posts}
                    types={this.categories}
                    page={this.page}
                    all_pages={this.all_pages}
                    order={this.order}
                    changeOrder={this.changeOrder.bind(this)}
                    changePage={this.changePage.bind(this)}
                    editFunction={this.openEditForm.bind(this)}
                    deleteFunction={this.deletePost.bind(this)}
                />

            </>);
        }
        return (<div className="row">
                    <div className="col-lg-12">
                        <h2>{getStaticText('ttop_section_title')}</h2>
                    </div>
                    {content}
                </div>);
    }

}


export default TransportationToOrderPostsPage;